import { INVALIDATE_LIVRE_JOURNAL, INVALIDATE_PLAN_COMPTABLE } from 'actions/invalidationTags';
import { ApiMananger } from 'actions/rtkquery';
import {
  ADD_LIVREJOURNAUX_API_ROUTE,
  UPDATE_LIVREJOURNAUX_API_ROUTE,
  DELETE_LIVREJOURNAUX_API_ROUTE,
  ADD_LIVREJOURNAUX_PIECEJOINTE_API_ROUTE
} from 'routes/api/endpoints';

const codeJournauxApi = ApiMananger.injectEndpoints({
  endpoints: (build) => ({
    // Mutation for creating a new fournisseur instance
    createLivreJournal: build.mutation({
      query(body) {
        return {
          url: ADD_LIVREJOURNAUX_API_ROUTE,
          method: 'POST',
          body,
        };
      },
      invalidatesTags: [INVALIDATE_LIVRE_JOURNAL],
    }),

    addPieceJointe: build.mutation({
      query(body) {
        return {
          url: `${ADD_LIVREJOURNAUX_PIECEJOINTE_API_ROUTE}`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: [INVALIDATE_PLAN_COMPTABLE],
    }),

    // Mutation for updating an existing fournisseur instance
    updateLivreJournal: build.mutation({
      query: ({ id, ...updateData }) => ({
        url: `${UPDATE_LIVREJOURNAUX_API_ROUTE}${id}/`,
        method: 'PUT',
        body: updateData,
      }),
      invalidatesTags: [INVALIDATE_LIVRE_JOURNAL], // Invalidate the cache tags to refetch fournisseur-related data
    }),

    // Mutation for deleting an existing fournisseur instance
    deleteLivreJournal: build.mutation({
      query: ({id}) => ({
        url: `${DELETE_LIVREJOURNAUX_API_ROUTE}${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: [INVALIDATE_LIVRE_JOURNAL], // Invalidate to refetch fournisseur-related data
    }),

    // More fournisseur-related mutations and queries can be added here...
  }),
  overrideExisting: false,
});

export const {
  useCreateLivreJournalMutation,
  useUpdateLivreJournalMutation,
  useDeleteLivreJournalMutation,
  useAddPieceJointeMutation
} = codeJournauxApi;
